var _rect, _circle, _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDown(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 100,
    viewBox: "0 0 34 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 32.8462,
    height: 55.4103,
    rx: 16.4231,
    stroke: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9259,
    cy: 19.0392,
    r: 1.41026,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2737_28171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6668 73.2973L23.0129 66.9512L24.8258 68.764L16.6668 76.923L8.50781 68.764L10.3206 66.9512L16.6668 73.2973Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_2737_28171)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 88.4615L11.2266 83.0218L13.0407 81.209L16.6663 84.8359L20.2919 81.209L22.106 83.0218L16.6663 88.4615Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2737_28171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.7692,
    height: 30.7692,
    fill: "white",
    transform: "translate(1.28125 56.4102)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_2737_28171"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30.7692,
    height: 30.7692,
    fill: "white",
    transform: "translate(1.28125 69.2305)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.08939aa69b960fa256af945e7b34fe60.svg";
export { ForwardRef as ReactComponent };